import { render, staticRenderFns } from "./RecruitmentContactList.vue?vue&type=template&id=beb53094&scoped=true&lang=pug"
import script from "./RecruitmentContactList.vue?vue&type=script&lang=ts"
export * from "./RecruitmentContactList.vue?vue&type=script&lang=ts"
import style0 from "./RecruitmentContactList.vue?vue&type=style&index=0&id=beb53094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beb53094",
  null
  
)

export default component.exports